import { useEffect } from 'react';

const Home = () => {
  useEffect(() => {
    alert(`loaded`);
  }, []);
  return (
    <>
      <h1>Teste</h1>
    </>
  );
};

export default Home;
